import React from 'react'
import css from './style.css'
import { GridItem } from '../grid'
import ScaleGroup from './scale_group'

const boxTop = [css.box, css.top].join(' ')
const boxBottom = [css.box, css.bottom].join(' ')

const ImageScale = props => {
  let style = {}
  if (props.imgHeight) {
    style['height'] = props.imgHeight
  }
  if (props.item.imgStyle) {
    style = Object.assign({}, style, props.item.imgStyle)
  }
  return (
    <GridItem key={props.index} nopad col={`1/${props.numItemsInGroup}`} customStyle={css.item}>
      <div className={css.imgContainer} style={props.imgHeight ? {'height': props.imgHeight} : {}}>
        <img src={props.item.img} className={css.img} style={style} />
      </div>
      <div className={boxTop} />
      <div className={boxBottom} />
      <div className={css.element}>{props.item.name}</div>
    </GridItem>
  )
}

export default ScaleGroup(ImageScale)



// WEBPACK FOOTER //
// ./src/components/scale/image_scale.js